module.exports = __webpack_public_path__ + "media/add-ons/webinar@1x-049ef6e3.png";